import GreetAdmin from "../../components/Admin/GreetAdmin";
import CustomerSheetList from "../../components/Admin/CustomerSheets/CustomerSheetList";
import CustomerSheetHeader from "../../components/Admin/CustomerSheets/CustomerSheetHeader";

export default function AdminHome() {
  return (
    <section className="space-y-5">
      <GreetAdmin />
      <CustomerSheetHeader />
      <CustomerSheetList />
    </section>
  );
}
